// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"0f7832a5","6850":"19a857a8"}[chunkId] + ".chunk.css";
};